module.exports = __webpack_public_path__ + "static/media/27.170c05a9.png";